import { jsx as c } from "react/jsx-runtime";
import { createStyles as l, rem as s } from "@mantine/core";
import { useMemo as n } from "react";
import { Badge as i } from "../Badge/index.js";
import "../ProductTile/ProductTileSkeleton.js";
const t = l((r) => ({
  root: {
    height: s(24),
    fontSize: r.fontSizes.sm,
    lineHeight: 1,
    padding: `${r.spacing.sm} ${r.spacing.md}`,
    borderRadius: r.radius.xs
  },
  // Variant colours
  clearance: {
    backgroundColor: r.colors.yellow[4],
    color: r.colors.black[4]
  },
  featured: {
    backgroundColor: r.colors.teal[4],
    color: r.white
  },
  freeGift: {
    backgroundColor: r.white,
    color: r.colors.teal[7],
    borderColor: r.colors.teal[7]
  },
  new: {
    backgroundColor: r.colors.orange[4],
    color: r.white
  },
  sale: {
    backgroundColor: r.other.semanticColors.error,
    color: r.white
  },
  specialOffer: {
    backgroundColor: r.colors.blue[4],
    color: r.white
  },
  soldOut: {
    backgroundColor: r.colors.gray[4],
    color: r.white
  }
})), w = ({ style: r }) => {
  const { classes: o, cx: e } = t(), a = n(() => {
    switch (r) {
      case "clearance":
        return "Clearance";
      case "featured":
        return "Featured";
      case "free-gift":
        return "Free Gift";
      case "new":
        return "New";
      case "sale":
        return "Sale";
      case "special-offer":
        return "Special Offer";
      case "soldout":
        return "Sold Out";
    }
  }, [r]);
  return c(i, { className: e({ [o.clearance]: r === "clearance" }, { [o.featured]: r === "featured" }, { [o.freeGift]: r === "free-gift" }, { [o.new]: r === "new" }, { [o.sale]: r === "sale" }, { [o.specialOffer]: r === "special-offer" }, { [o.soldOut]: r === "soldout" }), classNames: {
    root: o.root
  }, variant: r === "free-gift" ? "outline" : "filled", children: a });
};
export {
  w as ProductBadge
};
